export default __webpack_public_path__ + "static/media/artwork-card-5.9838c99a.png";